import { render, staticRenderFns } from "./DarkModeToggle.vue?vue&type=template&id=00f62ef0&"
import script from "./DarkModeToggle.vue?vue&type=script&lang=js&"
export * from "./DarkModeToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00f62ef0')) {
      api.createRecord('00f62ef0', component.options)
    } else {
      api.reload('00f62ef0', component.options)
    }
    module.hot.accept("./DarkModeToggle.vue?vue&type=template&id=00f62ef0&", function () {
      api.rerender('00f62ef0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/navigation/DarkModeToggle.vue"
export default component.exports